var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 116,
    viewBox: "0 0 413 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_438_2582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 353,
    height: 56,
    rx: 16,
    fill: "#0074A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 353,
    height: 56,
    rx: 16,
    fill: "url(#paint0_radial_438_2582)",
    fillOpacity: 0.53
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.727 48V64H192.148L184.609 53.1016H184.477V64H181.578V48H184.172L191.703 58.9062H191.844V48H194.727ZM203.072 64.2344C201.869 64.2344 200.83 63.9844 199.955 63.4844C199.085 62.9792 198.416 62.2656 197.947 61.3437C197.479 60.4167 197.244 59.3255 197.244 58.0703C197.244 56.8359 197.479 55.7526 197.947 54.8203C198.421 53.8828 199.083 53.1536 199.932 52.6328C200.781 52.1068 201.778 51.8438 202.924 51.8438C203.663 51.8438 204.361 51.9635 205.018 52.2031C205.679 52.4375 206.262 52.8021 206.768 53.2969C207.278 53.7917 207.679 54.4219 207.971 55.1875C208.262 55.9479 208.408 56.8542 208.408 57.9062V58.7734H198.572V56.8672H205.697C205.692 56.3255 205.575 55.8437 205.346 55.4219C205.117 54.9948 204.796 54.6589 204.385 54.4141C203.979 54.1693 203.505 54.0469 202.963 54.0469C202.385 54.0469 201.877 54.1875 201.439 54.4687C201.002 54.7448 200.661 55.1094 200.416 55.5625C200.176 56.0104 200.054 56.5026 200.049 57.0391V58.7031C200.049 59.401 200.176 60 200.432 60.5C200.687 60.9948 201.044 61.375 201.502 61.6406C201.96 61.901 202.497 62.0312 203.111 62.0312C203.523 62.0312 203.895 61.974 204.229 61.8594C204.562 61.7396 204.851 61.5651 205.096 61.3359C205.34 61.1068 205.525 60.8229 205.65 60.4844L208.291 60.7812C208.124 61.4792 207.807 62.0885 207.338 62.6094C206.874 63.125 206.281 63.526 205.557 63.8125C204.833 64.0937 204.005 64.2344 203.072 64.2344ZM212.855 52L215.277 56.4297L217.738 52H220.73L217.113 58L220.793 64H217.816L215.277 59.6797L212.762 64H209.762L213.418 58L209.855 52H212.855ZM228.91 52V54.1875H222.012V52H228.91ZM223.715 49.125H226.543V60.3906C226.543 60.7708 226.6 61.0625 226.715 61.2656C226.835 61.4635 226.991 61.599 227.184 61.6719C227.376 61.7448 227.59 61.7812 227.824 61.7812C228.001 61.7812 228.163 61.7682 228.309 61.7422C228.46 61.7161 228.574 61.6927 228.652 61.6719L229.129 63.8828C228.978 63.9349 228.762 63.9922 228.48 64.0547C228.204 64.1172 227.866 64.1536 227.465 64.1641C226.757 64.1849 226.118 64.0781 225.551 63.8437C224.983 63.6042 224.533 63.2344 224.199 62.7344C223.871 62.2344 223.71 61.6094 223.715 60.8594V49.125Z",
    fill: "#F1EAEA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_438_2582",
    x: 0,
    y: 0,
    width: 413,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_2582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_2582",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_438_2582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_438_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.844 39.0164) rotate(13.2196) scale(154.555 74.1861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBg);
export default __webpack_public_path__ + "static/media/buttonBg.7e47c7abcdbbcc7c9693c31844b60950.svg";
export { ForwardRef as ReactComponent };